export function escapeHtml (value) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(value, 'text/html')
  return doc.body.textContent || ''
}

export function sanitizeString (string) {
  return string
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/?(ul|li)\s*\/?>/gi, '\n')
    .replace(/<\/?[^>\s/]+(?:\s[^>]*?)?>/g, '')
}

/*
  Converts any camel or pascal case string to kebab case.
  Will be updated to manage other kinds of casing if needed.
*/
export function toKebabCase (str) {
  return str.split(/(?=[A-Z])/).join('-').toLowerCase()
}
